import { compose } from "recompose";
import withApiErrorWrapper from "../HandleApiErrorWrapperNonRedux";
import StoreZoneSceneLevelsPageWrapper from "./StoreZoneSceneLevelsPageWrapper";
import withCommissionedLightingStores from "../WithCommissionedLightingStores";

export default compose(
  withApiErrorWrapper,
  withCommissionedLightingStores
)(StoreZoneSceneLevelsPageWrapper);
